import React, { RefObject } from 'react'
import { Button } from '@fareye/ui'
import { useTranslation } from '@fareye/common'

interface IEditFeatureButton {
  setSelectedDataForEdit(val: any): void
  selectedDataForEdit: any
  containerRef: RefObject<HTMLDivElement>
}
export function EditFeatureButton({
  setSelectedDataForEdit,
  selectedDataForEdit,
  containerRef
}: IEditFeatureButton) {
  const { t } = useTranslation()
  return (
    <Button
      onClick={() => {
        containerRef.current &&
          containerRef.current.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        setSelectedDataForEdit(selectedDataForEdit)
      }}
    >
      {t('Edit')}
    </Button>
  )
}
